/* eslint-disable no-unused-expressions */
/* eslint-disable no-plusplus */
/* eslint-disable id-length */

const HeightMatrix = class {
  constructor(x, y, getSkuProductDimensions, getCompatibilitySegmentGroups, compatibilitySegments) {
    this.x = x;
    this.y = y;
    this.productMatrix = [];
    this.groups = [];
    this.maxHeight = 0;
    this.getSkuProductDimensions = getSkuProductDimensions;
    this.getCompatibilitySegmentGroups = getCompatibilitySegmentGroups;
    this.compatibilitySegments = compatibilitySegments;
    this.initialize();
  }

  initialize = () => {
    for (let i = 0; i < this.y; i++) {
      this.productMatrix[i] = [];
      for (let j = 0; j < this.y; j++) {
        this.productMatrix[i][j] = [];
      }
    }
  }

  pushProduct = (x, y, Sku) => {
    this.productMatrix[x][y].push(Sku);
  };

  pushGroupProducts = (group, productSkus) => {
    const xx = group.split(':');
    const [x1, y1] = xx[0].split(',');
    const [x2, y2] = xx[1].split(',');
    for (let i = x1; i <= x2; i++) {
      for (let j = y1; j <= y2; j++) {
        productSkus.forEach((sku) => this.productMatrix[i][j].push(sku));
      }
    }
  };

  getBucketProducts = (x, y) => {
    return this.productMatrix[x][y];
  };

  sumBucketProductsHeight = (x, y) => {
    let bucketHeight = 0;
      this.getBucketProducts(x, y)?.forEach((Sku) => {
        bucketHeight += this.getSkuProductDimensions(Sku)?.height;
      });
      this.maxHeight = bucketHeight > this.maxHeight ? bucketHeight : this.maxHeight;
      return bucketHeight;
  };

  calculateMaxHeight = () => {
    this.getCompatibilitySegmentGroups()?.forEach((group) => {
      const productSkus = [];
      this.compatibilitySegments[group]?.forEach((product) => {
        productSkus.push(product.Sku);
      });
      this.pushGroupProducts(group, productSkus);
    });

    for (let i = 0; i < this.y; i++) {
      for (let j = 0; j < this.y; j++) {
        const currentHeight = this.sumBucketProductsHeight(i, j);
        this.maxHeight = currentHeight > this.maxHeight ? currentHeight : this.maxHeight;
      }
    }
    return this.maxHeight;
  }
};

export default HeightMatrix;
